import { Injectable } from '@angular/core';
import { UtilityService } from './utility.service';
import { AngularFireDatabase, AngularFireObject, AngularFireList } from 'angularfire2/database';
import { Constants } from '../config/Constants';
import { Observable } from 'rxjs/Observable';
import * as firebase from 'firebase/app';
import { ProfileImageUpload } from '../models/profile-image-upload';
import { Sponsors } from '../models/sponsors';
import { ContentsMandatory } from '../models/contents-mandatory';
import { of } from 'rxjs/observable/of';

@Injectable()
export class SponsorsService {

	//basePath:string = "SponsorsImages/";
	constructor(private db: AngularFireDatabase, private utilityService: UtilityService) {
	}

	getSingleSponsor(eventId: string, sponsorId: string): Observable<Sponsors> {
		let data: AngularFireObject<Sponsors> = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.SPONSORS_URL + '/' + sponsorId);
		return data.valueChanges();
	}

	getSponsorsList(eventId: string) {
		if (this.utilityService.isLogged()) {
			return this.db.list(Constants.EVENT_URL + '/' + eventId + Constants.SPONSORS_URL);
		}
		return null;
	}

	addSponsorDetails(sponsor: Sponsors, eventId: string) {
		return this.db.list(Constants.EVENT_URL + '/' + eventId + Constants.SPONSORS_URL).push(sponsor).key;
	}

	updateSponsorDetails(sponsor: Sponsors, eventId: string, sponsorId: string): Promise<any> {
		console.log(sponsor, eventId, sponsorId);
		return this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.SPONSORS_URL + '/' + sponsorId).set(sponsor);
	}

	updateSponsorPosition(eventID, sponsorsList) {
		// TODO: This should be 1 query. Right now ther are multiple.
		for (let item of sponsorsList) {
			let key = item.$key;
			this.db.object(Constants.EVENT_URL + '/' + eventID + Constants.SPONSORS_URL + '/' + key).update({ position: item.position });
		}
	}

	getSponsorType(eventId: string): Observable<Sponsors> {
		let data: AngularFireObject<Sponsors> = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.CATEGORY_SPONSORS);
		return data.valueChanges();
	}

	deletegetSponsor(sponsor: Sponsors, eventId: string, sponsorsList) {
		if (sponsorsList.length <= 0) {
			return this.db.list(Constants.EVENT_URL + '/' + eventId + Constants.SPONSORS_URL).remove(sponsor.$key);
		} else {
			this.db.list(Constants.EVENT_URL + '/' + eventId + Constants.SPONSORS_URL).remove(sponsor.$key);
			let i = 0;
			for (let item of sponsorsList) {
				let key = item.$key;
				var data = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.SPONSORS_URL + '/' + key).update({ position: item.position });
				i++;
				if (i == sponsorsList.length) {
					return data;
				}

			}
		}

	}

}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/services/sponsors.service.ts